import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";
import { cn } from "./cn.js";
const STYLE = {
    info: "border-accent/30 bg-accent/5",
    success: "border-success/30 bg-success/5",
    warning: "border-warning/30 bg-warning/5",
    danger: "border-danger/30 bg-danger/5",
};
const ICON = { info: Info, success: CheckCircle2, warning: AlertTriangle, danger: XCircle };
const ICON_COLOR = {
    info: "text-accent",
    success: "text-success",
    warning: "text-warning",
    danger: "text-danger",
};
export function Notice({ tone = "info", title, children, className, }) {
    const Icon = ICON[tone];
    return (_jsxs("div", { role: tone === "danger" ? "alert" : "status", className: cn("flex gap-3 rounded-field border p-3 text-sm animate-rise", STYLE[tone], className), children: [_jsx(Icon, { className: cn("mt-0.5 size-4 shrink-0", ICON_COLOR[tone]), "aria-hidden": true }), _jsxs("div", { className: "min-w-0 space-y-1", children: [title && _jsx("p", { className: "font-medium text-fg", children: title }), children && _jsx("div", { className: "text-muted", children: children })] })] }));
}
//# sourceMappingURL=Notice.js.map